import actionConstants from '../constants/ActionConstants';

const initialState = {
  isFetching: false,
  isSuccess: false,
  list: [],
  dismissed: [],
  error: '',
};

const remindersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.GET_REMINDERS_REQUEST:
      return {
        ...state,
        isFetching: true,
        isSuccess: false,
        error: '',
      };
    case actionConstants.GET_REMINDERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        error: '',
        list: action.payload?.reminders || [],
        dismissed: [],
      };
    case actionConstants.GET_REMINDERS_FAILURE:
      return {
        ...state,
        isFetching: false,
        isSuccess: false,
        error: action.message,
      };
    case actionConstants.DISMISS_REMINDER: {
      const reminderType = action.payload?.reminderType;
      if (!reminderType || state.dismissed.includes(reminderType)) return state;
      return {
        ...state,
        dismissed: [...state.dismissed, reminderType],
      };
    }
    case actionConstants.RESET_ALL_REDUCERS:
      return { ...initialState };
    default:
      return state;
  }
};

export default remindersReducer;
